import React from 'react'
import { IconButton } from '@common/material'
import LaunchIcon from '@mui/icons-material/Launch'
import { PermitCard } from '@elements'
import { useModal } from '@common/GlobalModal'
import { PermitDetailsModal } from '@modules/permitDetails/PermitDetailsModal'
import { PermitBase } from '@core/entities/permit/PermitBase'

type Props = {
  organisationId: number
  parentPermit?: PermitBase
  childPermits?: Array<PermitBase>
}

export const ParentChildPermitsList: React.FC<Props> = ({
  organisationId,
  parentPermit,
  childPermits = [],
}) => {
  const { showModal } = useModal()

  const renderCard = (permit: PermitBase, isChildPermit: boolean) => (
    <PermitCard
      key={permit.id}
      templateName={permit.template?.name}
      summary={permit.summary}
      status={permit.status}
      startsOn={permit.startsOn}
      endsOn={permit.endsOn}
      location={permit.location}
      shortUUID={permit.shortUUID}
      permitHolder={permit.permitHolder}
      isChildPermit={isChildPermit}
      sx={{ mb: 2 }}
      icon={
        <IconButton
          color='primary'
          size='small'
          onClick={() => {
            showModal(
              <PermitDetailsModal
                organisationId={organisationId}
                permitId={permit.id}
              />,
            )
          }}
        >
          <LaunchIcon />
        </IconButton>
      }
    />
  )

  return (
    <>
      {parentPermit && renderCard(parentPermit, false)}
      {childPermits.map((child) => renderCard(child, true))}
    </>
  )
}
